var map = {
	"./n4s/login/login.module": [
		"./src/app/n4s/login/login.module.ts",
		"n4s-login-login-module"
	],
	"app/demo/custom-pages/forgot-password/forgot-password.module": [
		"./src/app/demo/custom-pages/forgot-password/forgot-password.module.ts",
		"common",
		"app-demo-custom-pages-forgot-password-forgot-password-module"
	],
	"app/demo/custom-pages/register/register.module": [
		"./src/app/demo/custom-pages/register/register.module.ts",
		"common",
		"app-demo-custom-pages-register-register-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;